<template>
  <div class="filters-list">
    <SkeletonLoader
      v-if="isLoading"
      show-animation
      data-testid="filters-list-loading"
      class="filters-list__loader"
    >
      <div
        v-for="index in 2"
        :key="index"
        class="filters-list__button--loading"
      />
    </SkeletonLoader>
    <div v-else class="filters-list__container">
      <HorizontalSlider>
        <FilterOption
          v-for="(filter, index) in filters.available"
          :key="index"
          class="filters-list__button"
          :active="String(filter.value) === filters.selected"
          :option="formatFilter(filter)"
          @on-click="handleOnSelectFilter"
        />
      </HorizontalSlider>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  FilterOption,
  IFilterOption
} from '@/modules/common/components/FilterOption';
import { HorizontalSlider, SkeletonLoader } from '@warrenbrasil/nebraska-web';
import { FilterData, StringFormatted } from '@/modules/trade/types';

@Component({
  components: { FilterOption, HorizontalSlider, SkeletonLoader }
})
export default class FiltersList extends Vue {
  @Prop({ type: Object, required: true })
  readonly filters!: FilterData;

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  formatFilter(filter: StringFormatted) {
    return {
      value: filter.value,
      label: filter.formatted
    };
  }

  handleOnSelectFilter(option: IFilterOption) {
    this.$emit('select-filter', option);
  }
}
</script>

<style lang="less" scoped>
@media @mobile {
  .filters-list {
    width: 100%;

    &__content {
      flex-direction: column;
    }
  }
}
.filters-list {
  &__loader {
    padding: @size-spacing-x300 0;
    display: flex;
  }

  &__container {
    display: flex;
  }

  &__content {
    display: flex;
    flex: 1;
  }

  &__button {
    &:not(:last-of-type) {
      margin-right: @size-spacing-x300;
    }

    &--loading {
      width: 100px;
      height: @size-spacing-x600;
      border-radius: 32px;
      margin-right: @size-spacing-x300;
    }
  }
}
</style>
